import { render, staticRenderFns } from "./pfTask.vue?vue&type=template&id=179be732&scoped=true&"
import script from "./pfTask.vue?vue&type=script&lang=js&"
export * from "./pfTask.vue?vue&type=script&lang=js&"
import style0 from "./pfTask.vue?vue&type=style&index=0&id=179be732&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179be732",
  null
  
)

export default component.exports